// extracted by mini-css-extract-plugin
export var chevron = "_38-2";
export var chevronCollapsed = "_38-3";
export var collapsibleHeader = "_38-1";
export var container = "_38-0";